import { useEffect, useRef, useState } from 'react';
import { OkrAccordion } from '@workboard/ui-okr';
import { LazyKrLoader } from './LazyKrLoader';
import OkrService from '../../services/okrs';

const lazyPermissionLoader = async (id) => {
  try {
    const [_, result] = await OkrService.getObjectivesPermissionsById({ id });
    return result;
  } catch {
    return {};
  }
};

export const LazyObjectiveAccordion = ({
  context,
  obj,
  krsLoader,
  externalExpanded,
  handleChange,
  initialKrs,
  }) => {
  const [loading, setLoading] = useState(false);
  const [krs, setKrs] = useState(initialKrs(obj.id));
  const prevExpanded = useRef(externalExpanded);
  
  useEffect(() => {
    if (externalExpanded) {
      krsLoader(obj, setLoading, !prevExpanded.current, setKrs).then(
        ([newKrs, shouldReload]) => {
          setLoading(false);
          if (shouldReload) {
            setKrs(newKrs);
          }
        },
      );
  
      if (!prevExpanded.current) {
        prevExpanded.current = externalExpanded;
      }
    } else if (prevExpanded.current) {
      prevExpanded.current = externalExpanded;
    }
}, [externalExpanded, obj.id, krsLoader, setKrs, setLoading]);
  
  return (
    <OkrAccordion
      context={context}
      objective={obj}
      data-oid={obj.id}
      onChange={handleChange}
      expanded={externalExpanded}
      onGetPermission={lazyPermissionLoader}
      options={{
        hideTeam: true,
        hideOwner: true,
      }}
      variant="circle"
    >
      <LazyKrLoader loading={loading} krs={krs} />
    </OkrAccordion>
  );
};
